import { Panel } from 'component/Space/Panel'
import { observer } from 'mobx-react-lite'
import { Thickness } from 'page/ProfileScreen/BodySizes/Thickness'
import { store } from 'store/store'

export const Thicknesses = observer(() => {
  const { cfg, shape } = store.profile.form
  const thicknesses = cfg.shape_types_config[shape] ?? cfg.body_thickness

  return <Panel>
    {thicknesses.map(value => <Thickness key={value} size={value} />)}
  </Panel>
})
